export default __webpack_public_path__ + "static/media/019-tower of london.e7413073.svg";